<template>
 <div  v-if="hasRole(roles.RW_REAL_ESTA_ADMIN)">
    <div class="d-flex ">
    <div class="col-md-3">
    <formSearchRequest v-on:SearchItems="GetFilter" ></formSearchRequest>
  </div>
  <div class="col-md-9">
      <tablechangedate ref="tableChangeDateComponent" :key="tablereload" v-on:deleteRequest="deleteRequest"></tablechangedate>

  </div>
</div>
 </div>

</template>

<script>
import changedateofinstallment from './changedateofinstallment'
export default changedateofinstallment
</script>

<style scoped>
#card-sales{
  height: 100%;
  width: 100%;
  padding: 15px;
  border: 1px solid rgb(180, 180, 180);
  background-color: white;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/changedateofinstallment/changedateofinstallment.vue